import { ProgramRole } from '@app/shared/enums/program-role.enum';
import { SiteRole } from '@app/shared/enums/site-role.enum';

export class AclItemApiModel {
  public presetName?: string;
  public Caption?: string;
  public Originator?: string;
  public Type: number;
  public UserId: string;
  public ProgramRole: ProgramRole | null;
  public SiteRole: SiteRole | null;
  public GroupId: number | null;
  public LocationId: number | null;
  public TrackRelatedToSubject: boolean;

  constructor(presetName?: string, presetValues?: any) {
    this.presetName = presetName || 'Unnamed preset';

    if (!presetValues) {
      presetValues = {};
    }

    this.Type = presetValues.Type || 0;
    this.UserId = presetValues.UserId || null;
    this.SiteRole = presetValues.SiteRole || null;
    this.GroupId = presetValues.GroupId || null;
    this.LocationId = presetValues.LocationId || null;
    this.TrackRelatedToSubject = presetValues.TrackRelatedToSubject || false;
    this.ProgramRole = presetValues.ProgramRole === undefined ? null : presetValues.ProgramRole;
    this.Caption = presetValues.Caption || '';
    this.Originator = presetValues.Originator || '';
  }

  public deserialize(data: Object): AclItemApiModel {
    Object.assign(this, data);

    return this;
  }

  public compare(preset: AclItemApiModel): boolean {
    return (
      this.Type === preset.Type &&
      this.UserId === preset.UserId &&
      this.ProgramRole === preset.ProgramRole &&
      this.SiteRole === preset.SiteRole &&
      this.GroupId === preset.GroupId &&
      this.LocationId === preset.LocationId &&
      this.TrackRelatedToSubject === preset.TrackRelatedToSubject
    );
  }

  public detectPresetName(presets: AclItemApiModel[]): AclItemApiModel {
    return presets.find((p) => this.compare(p)) ?? this;
  }
}
